import { render, staticRenderFns } from "./ControlMiniComponent.vue?vue&type=template&id=6ce4a660&"
import script from "./ControlMiniComponent.vue?vue&type=script&lang=js&"
export * from "./ControlMiniComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports